
import { defineComponent } from 'vue';
import router from "@/router";
import UserInfoDto from "@/dto/UserInfoDto";
import store from "@/store"; // @ is an alias to /src
import VueQrcode from "@chenfengyuan/vue-qrcode";

export default defineComponent({
    name: 'HomeView',
    methods: {
        move(path: string){
            router.push(path)
        }
    },
  components: {
    VueQrcode
  },
  data(){
    return {
      localUserId: '',
      uuu: {} as UserInfoDto,
      ready: false,
      qrOption: {
        errorCorrectionLevel: "M",
        maskPattern: 0,
        margin: 0,
        scale: 2,
        width: 200,
        color: {
          dark: "#000000FF",
          light: "#FFFFFFFF"
        }
      }
    }
  },
  computed: {
    /**
     * ユーザー情報(store)
     */
    userInfo: {
      get(): UserInfoDto {
        return store.getters.userInfo as UserInfoDto
      },
      set(userInfo: UserInfoDto) {
        store.commit('setUserInfo', userInfo)
      }
    },
  }
});
